<div class="text-center mt-5">
  <h5 *ngIf="!isPeri" [innerHtml]="'Home.Title' | labelText"></h5>
  <h5 *ngIf="isPeri" [innerHtml]="'Home.Title2' | labelText"></h5>
</div>

<app-client-prospect-switcher></app-client-prospect-switcher>

<div [ngClass]="{ hidden: clientType === null }">
  @if (isContract) {
    <app-authentication-client *ngIf="isContract && !authorized"></app-authentication-client>

    <app-registration-form
      *ngIf="isContract && authorized"
      [readOnlyMode]="authorized"
      [isSubmitting]="isSubmittingRegistration"
      (submitRegistration)="onSubmitRegistration($event)"
    ></app-registration-form>

    <app-advertisement-source-client *ngIf="isContract && authorized"></app-advertisement-source-client>

    <div class="row mt-5" *ngIf="isContract && authorized">
      <div class="col-12 text-center">
        <button
          type="button"
          class="btn btn-blue valider"
          [disabled]="
            registrationFormComponent?.isRegistrationFormValid !== true ||
            advertisementSourceClient?.isMifFormValid !== true ||
            isSubmittingRegistration
          "
          (click)="registrationFormComponent?.onSubmitRegistration()"
        >
          {{ 'Common.Validate' | labelText }}
        </button>
      </div>
    </div>
  }

  @if (isProspect) {
    <app-authentication-prospect (completed)="onProspectRegistrationCompleted($event)"></app-authentication-prospect>
  }
</div>
